var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/down"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75236 9.45944L11.9713 7.24049C12.6222 6.58962 13.6775 6.58962 14.3283 7.24049C14.9792 7.89136 14.9792 8.94664 14.3283 9.59751L11.0285 12.8973C10.6782 13.2476 10.2108 13.4094 9.75236 13.3827C9.2939 13.4094 8.8265 13.2476 8.47622 12.8973L5.17639 9.59751C4.52551 8.94664 4.52551 7.89136 5.17639 7.24049C5.82726 6.58962 6.88254 6.58962 7.53341 7.24049L9.75236 9.45944Z",
    fill: "#E37B3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4993",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 11,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75236 9.45944L11.9713 7.24049C12.6222 6.58962 13.6775 6.58962 14.3283 7.24049C14.9792 7.89136 14.9792 8.94664 14.3283 9.59751L11.0285 12.8973C10.6782 13.2476 10.2108 13.4094 9.75236 13.3827C9.2939 13.4094 8.8265 13.2476 8.47622 12.8973L5.17639 9.59751C4.52551 8.94664 4.52551 7.89136 5.17639 7.24049C5.82726 6.58962 6.88254 6.58962 7.53341 7.24049L9.75236 9.45944Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 20,
    height: 20,
    fill: "#E37B3C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.f51a171574aa62323fd014686e1860cf.svg";
export { ForwardRef as ReactComponent };